import { render, staticRenderFns } from "./MOISettings.vue?vue&type=template&id=56963d9b&scoped=true"
import script from "./MOISettings.vue?vue&type=script&lang=js"
export * from "./MOISettings.vue?vue&type=script&lang=js"
import style0 from "./MOISettings.vue?vue&type=style&index=0&id=56963d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56963d9b",
  null
  
)

export default component.exports